// Pass in an element ID of an anchor that has class hidden and tabindex=-1, e.g.:
// <a id="focusResetAnchor" tabindex="-1" class="hidden" />

export default function focusReset(id: string): void {
  const focusResetElement : HTMLElement | null = document.getElementById(id)

  if (focusResetElement) {
    focusResetElement.classList.remove('hidden')
    focusResetElement.focus()
    focusResetElement.blur()
    focusResetElement.classList.add('hidden')
  }
}
